module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "650",
      "title": "Invoice Payment Sample Data",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "close": function($event) {
        _vm.$emit('onClose')
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "invoiceNumber",
      "label": "Invoice Number",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "accountCode",
      "label": "Account Code",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "amount",
      "label": "Amount",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "reference",
      "label": "Reference",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "paymentDate",
      "label": "Payment Date",
      "width": "130"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Invoice payment date format should be "), _c('b', [_vm._v("MM/dd/yyyy")]), _vm._v(" format. You can download sample file "), _c('a', {
    attrs: {
      "href": "https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Invoice_Payment_Import_Template.csv"
    }
  }, [_vm._v("here")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afa63134"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvoicePaymentPopup.vue
// module id = 246
// module chunks = 1